import $ from "jquery";
/**网站头部导航 */
function header_nav() {
    var nav_item = $(".common_header .nav_item");
    var _loop_1 = function (index) {
        var item = nav_item[index];
        var sub_nav_list;
        $(item).hover(function (e) {
            // 获取二级导航
            sub_nav_list = e.target.nextElementSibling;
            // 显示
            if (sub_nav_list) {
                var height_1 = sub_nav_list.children.length * 40;
                $(sub_nav_list).css({
                    display: "block",
                });
                setTimeout(function () {
                    $(sub_nav_list).css({
                        height: height_1,
                    });
                }, 20);
            }
        }, function () {
            // 隐藏
            if (sub_nav_list) {
                $(sub_nav_list).css({
                    height: 0,
                });
                setTimeout(function () {
                    $(sub_nav_list).css({
                        display: "none",
                    });
                }, 200);
            }
        });
    };
    for (var index = 0; index < nav_item.length; index++) {
        _loop_1(index);
    }
}
header_nav();
